import { render } from "./my-account.vue?vue&type=template&id=0edc4e25&ts=true"
import script from "./my-account.vue?vue&type=script&lang=ts"
export * from "./my-account.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__